{
  "buy": {
    "page": {
      "title": "Tickets kaufen"
    },
    "brand": {
      "name": "Elternverein Kaiseraugst",
      "logoAlt": "Logo Elternverein Kaiseraugst"
    },
    "loading": {
      "event": "Event wird geladen …"
    },
    "errors": {
      "missingEventId": "Es wurde kein Event angegeben.",
      "eventLoadFailed": "Das Event konnte nicht geladen werden. Bitte später erneut versuchen.",
      "purchaseFailed": "Der Kauf konnte nicht eingeleitet werden. Bitte später erneut versuchen.",
      "checkoutMissingUrl": "Die Bezahlung konnte nicht gestartet werden (kein Checkout-Link erhalten).",
      "statusFailed": "Der Status konnte nicht geladen werden.",
      "transactionFailed": "Die Zahlung wurde nicht abgeschlossen.",
      "transactionAbandoned": "Die Zahlung wurde abgebrochen.",
      "missingReturnParams": "Ungültiger Bestätigungslink.",
      "freeOnlyNeedsPayingTicket": "Ein freies Begleitpersonen-Ticket ist nur zusammen mit mindestens einem zahlenden Ticket erhältlich."
    },
    "banner": {
      "test": "TEST MODE — keine echte Zahlung.",
      "inactive": "Event ist nicht aktiv (Test-Modus)",
      "stopped": "Vorverkauf gestoppt (Test-Modus)"
    },
    "unavailable": {
      "inactive": {
        "title": "Event nicht verfügbar",
        "message": "Dieses Event ist derzeit nicht verfügbar."
      },
      "paused": {
        "title": "Vorverkauf pausiert",
        "message": "Der Vorverkauf ist leider vorübergehend nicht verfügbar. Bitte versuchen Sie es demnächst gerne noch einmal!"
      },
      "ended": {
        "title": "Vorverkauf beendet",
        "message": "Der Vorverkauf für diesen Event ist beendet. Möglicherweise sind an der Abendkasse noch Tickets erhältlich."
      },
      "over": {
        "title": "Dieses Event ist vorbei",
        "message": "Dieses Event hat bereits stattgefunden. Ein Ticketkauf ist nicht mehr möglich."
      },
      "backToWebsite": "Zurück zur Website"
    },
    "event": {
      "dateLabel": "Datum",
      "venueLabel": "Veranstaltungsort",
      "flyerAlt": "Event-Flyer: {event}",
      "flyerOpen": "Flyer vergrössern",
      "flyerClose": "Schliessen"
    },
    "membership": {
      "label": "Mitglied des Elternvereins Kaiseraugst",
      "hint": "Mitglieder erhalten vergünstigte Preise.",
      "detailsSummary": "Was heisst «Mitglied»?",
      "detailsWho": "Als Mitglied gilt eine Familie — Eltern und ihre Kinder, nicht aber weitere Verwandte wie Grosseltern — die beim Elternverein Kaiseraugst angemeldet ist und deren Jahresbeitrag bezahlt ist. Die Mitgliedschaft wird am Eingang geprüft.",
      "detailsAttribution": "Kinder gelten als Mitglied, wenn die Eltern Mitglied des Elternvereins Kaiseraugst sind. Eine Begleitperson gilt als Mitglied, wenn sie selbst Mitglied ist.",
      "detailsJoin": "Noch kein Mitglied? Der Beitritt ist direkt am Event möglich. Der Jahresbeitrag wird vor Ort oder nach der Anmeldung per Rechnung bezahlt (eine Online-Zahlung ist derzeit nicht möglich). Details und Jahresbeitrag: {link}.",
      "joinLinkLabel": "Mitglied werden"
    },
    "categories": {
      "title": "Tickets",
      "adult": "Erwachsene",
      "child": "Kinder",
      "memberSuffix": "(Mitglied)",
      "nonMemberSuffix": "(Nichtmitglied)",
      "intro": "Tickets werden für den Zutritt zur Filmvorführung benötigt — weitere Details unter «Gut zu wissen». Ein Ticket gilt für den ganzen Event und ermöglicht es, beide Filme zu schauen.",
      "accompanyingAdultLabel": "Erwachsene (Begleitperson, Mitglied)",
      "free": "kostenlos",
      "accompanyingAdultHint": "* Warum ein Ticket, wenn es kostenlos ist? Es gewährt einer Begleitperson (Erwachsene ab 18 Jahren) den Zutritt zur Filmvorführung, um die Kinder zu beaufsichtigen — und stellt sicher, dass pro Bestellung höchstens zwei Gratis-Tickets bezogen werden. Weitere Tickets sind möglicherweise an der Abendkasse am Event erhältlich.",
      "childAgeHint": "Kinder zahlen Eintritt ab Kindergarten.",
      "quantityLabel": "Anzahl",
      "decrease": "Eins weniger",
      "increase": "Eins mehr"
    },
    "goodToKnow": {
      "title": "Gut zu wissen",
      "publicArea": "Der Festwirtschaftsbereich (Essen und Trinken) ist für alle frei zugänglich — ein Ticket wird nur für die Filmvorstellungen benötigt.",
      "childcare": "Es gibt keine Kinderbetreuung: Die Eltern entscheiden, ob die Kinder den Film alleine schauen oder begleitet werden.",
      "weather": "Bei schlechtem Wetter finden die Vorstellungen in der Turnhalle statt — die Tickets bleiben gültig.",
      "delivery": "Nach dem Kauf werden die Tickets als PDF per E-Mail zugestellt. Der QR-Code wird am Eingang auf dem Handy oder ausgedruckt vorgezeigt.",
      "moreInfo": "Alle weiteren Details zum Event: {link}.",
      "moreInfoLinkLabel": "Website des Elternvereins"
    },
    "paymentOptions": {
      "online": "Online bezahlbar mit Visa, Mastercard, Maestro, American Express, Apple Pay und Google Pay.",
      "twint": "TWINT und PostFinance Pay sind online nicht möglich — an der Abendkasse sind in der Regel weitere Zahlungsarten wie TWINT oder Barzahlung möglich."
    },
    "summary": {
      "subtotal": "Zwischensumme",
      "total": "Gesamt"
    },
    "email": {
      "label": "E-Mail-Adresse",
      "confirmLabel": "E-Mail-Adresse bestätigen",
      "invalid": "Bitte gültige E-Mail-Adresse eingeben.",
      "mismatch": "E-Mail-Adressen stimmen nicht überein.",
      "hint": "Die Tickets werden an diese Adresse gesendet."
    },
    "terms": {
      "acceptLabel": "Ich akzeptiere die {agb} und die {privacy}.",
      "agbLinkLabel": "AGB (PDF)",
      "privacyLinkLabel": "Datenschutzerklärung"
    },
    "footer": {
      "contact": "Fragen zu Tickets: {email}",
      "eventInfo": "Infos zum Event"
    },
    "submit": {
      "label": "Jetzt bezahlen",
      "loading": "Einen Moment …",
      "disabledNoTickets": "Bitte mindestens ein Ticket wählen.",
      "disabledInactive": "Verkauf derzeit deaktiviert.",
      "disabledTerms": "Bitte die AGB und die Datenschutzerklärung akzeptieren."
    },
    "return": {
      "titlePending": "Bestellstatus",
      "titleCompleted": "Vielen Dank für Ihren Kauf!",
      "titleFailed": "Zahlung nicht abgeschlossen",
      "titleAbandoned": "Zahlung abgebrochen",
      "loading": "Bestellung wird geprüft …",
      "completedHeader": "Zahlung bestätigt",
      "completedHelp": "Die Tickets wurden als PDF an die angegebene E-Mail-Adresse ({email}) gesendet. Sie sind hier zusätzlich herunterladbar:",
      "downloadTicket": "Ticket {n} herunterladen",
      "downloadTicketLabeled": "Ticket {n} ({category}) herunterladen",
      "category": {
        "adult_member": "Erwachsene — Mitglied",
        "adult_nonmember": "Erwachsene — Nichtmitglied",
        "child_member": "Kind — Mitglied",
        "child_nonmember": "Kind — Nichtmitglied"
      },
      "backToEvent": "Zurück zur Event-Webseite",
      "checkInbox": "Falls keine E-Mail ankommt, lohnt sich ein Blick in den Spam-Ordner.",
      "stillPending": "Wir warten noch auf die Zahlungsbestätigung. Diese Seite aktualisiert sich automatisch.",
      "timedOut": "Die Bestätigung dauert länger als erwartet. Die Tickets werden per E-Mail zugestellt, sobald die Zahlung verbucht ist.",
      "timedOutRebuyHint": "Vor einem erneuten Kauf lohnt sich ein kurzer Blick ins E-Mail-Postfach – so wird nicht versehentlich doppelt gekauft.",
      "transactionId": "Bestellnummer",
      "backToBuy": "Zurück zum Ticketkauf"
    }
  }
}
